import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_QUOTA_DETAILS, GET_QUOTA_DETAILS_SUCCESS, GET_QUOTA_DETAILS_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getQuotaDetails({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/quota-summary-table`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_QUOTA_DETAILS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_QUOTA_DETAILS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_QUOTA_DETAILS_ERROR, payload: error });
  }
}

export function* watchGetQuotaDetails() {
  yield takeEvery(GET_QUOTA_DETAILS, getQuotaDetails);
}

function* watchGetQuotaDetailsSaga() {
  yield all([fork(watchGetQuotaDetails)]);
}

export default watchGetQuotaDetailsSaga;